import { StatePropertyRef } from './ExtendableStore';

export interface AdapterInfo {
    target: string;
    type: string;
    name: string;
    opts?: Readonly<Record<string, unknown>>;
}

export const CreateAdapterInfo = (target: string, type: string, name = '', opts = {}) => ({ target, type, name, opts }) as AdapterInfo;
export const AdapterInfo = StatePropertyRef<AdapterInfo>('adapter', CreateAdapterInfo('none', 'na', 'na'));
